export default __webpack_public_path__ + "static/media/card2@2x.fe3b7cdf.png";